import CheckOutContainer from "../../../../Components/Applications/ECommerce/CheckOut/CheckOutContainer";

const Checkout = () => {
  return <CheckOutContainer />;
};

export default Checkout;
